// D should be standalone type to avoid undefined field of T
//  T should not be null to allow detection of all T fields
export const nodeWithDefaults = <T extends object, D extends object>(
  obj: T,
  defaultValue: D,
) => {
  const data: T & D = {
    ...defaultValue,
    ...obj,
  }
  for (const [key, value] of Object.entries(defaultValue)) {
    if (typeof data[key as keyof typeof defaultValue] === 'undefined') {
      data[key as keyof D] = value;
    }
  }

  return data;
};

export const nullableWithDefaults = <T extends object>(
  obj: T,
  defaultValue: Partial<T> | null = null,
): T | null => {
  return obj !== undefined ? { ...defaultValue, ...obj } : null
}
